<div class="terms">
  <div id="terms__header" class="terms__header">
    <span>
      <img src="assets/logo-ravi.svg" routerLink="" />
    </span>
  </div>
  <div class="terms__body" *ngIf="!isPrivacyPolicy">
    <p class="terms__body__header">Terms and Conditions for Ravi’s Academy</p>
    <p class="terms__body__bold">Introduction</p>
    <p>
      These Website Standard Terms and Conditions written on this webpage shall
      manage your use of our website, Ravi’s Academy accessible at
      http://ravisacademy.com/. These Terms will be applied fully and affect to
      your use of this Website. By using this Website, you agreed to accept all
      terms and conditions written in here. You must not use this Website if you
      disagree with any of these Website Standard Terms and Conditions. Minors
      or people below 18 years old are not allowed to use this Website.
    </p>
    <p class="terms__body__bold">Intellectual Property Rights</p>
    <p>
      Other than the content you own, under these Terms, Ravi’s Academy and/or
      its licensors own all the intellectual property rights and materials
      contained in this Website. You are granted limited license only for
      purposes of viewing the material contained on this Website.
    </p>
  </div>
  <div class="terms__body" *ngIf="isPrivacyPolicy">
    <p class="terms__body__header">Privacy Policy for Ravi’s Academy</p>
    <p class="terms__body__bold">Introduction</p>
    <p>
      These Website Standard Terms and Conditions written on this webpage shall
      manage your use of our website, Ravi’s Academy accessible at
      http://ravisacademy.com/. These Terms will be applied fully and affect to
      your use of this Website. By using this Website, you agreed to accept all
      terms and conditions written in here. You must not use this Website if you
      disagree with any of these Website Standard Terms and Conditions. Minors
      or people below 18 years old are not allowed to use this Website.
    </p>
    <p class="terms__body__bold">Intellectual Property Rights</p>
    <p>
      Other than the content you own, under these Terms, Ravi’s Academy and/or
      its licensors own all the intellectual property rights and materials
      contained in this Website. You are granted limited license only for
      purposes of viewing the material contained on this Website.
    </p>
  </div>
</div>
<footer class="footer">
  <span class="footer--first"
    >378 Boston Post Road, Unit 214, Orange, CT 06477, USA</span
  >
  <span>info@ravisacademy.com</span>
  <span class="footer--last">(959) 300 0660</span>
</footer>
